import { useCallback } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { useSelectionMode } from '@editorHooks'

export const ADD_PLAN_IMAGE_CARDS_SELECTION_KEY = 'add-plan-image-cards'

/**
 * Toggles plan-image-card placement mode. Point pick and card creation are handled
 * by `PlanImageCardController` in the scene.
 */
const usePlanImageCardTool = (): { isActive: boolean; toggle: () => void } => {
  const { selectionModeKey, setSelectionMode, unsetSelectionMode } = useSelectionMode()

  const isActive = selectionModeKey === ADD_PLAN_IMAGE_CARDS_SELECTION_KEY

  const toggle = useCallback(() => {
    if (isActive) {
      unsetSelectionMode()
      return
    }
    setSelectionMode({
      key: ADD_PLAN_IMAGE_CARDS_SELECTION_KEY,
      message: 'Obere linke Ecke des Plan-Bildes anwählen',
    })
  }, [isActive, setSelectionMode, unsetSelectionMode])

  useHotkeys(['shift+i'], () => toggle(), [toggle])

  return { isActive, toggle }
}

export default usePlanImageCardTool
